import { render, staticRenderFns } from "./TypesCreateModal.vue?vue&type=template&id=c893a6b6&"
import script from "./TypesCreateModal.vue?vue&type=script&lang=js&"
export * from "./TypesCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports